import { Component } from "react";
import "../Styles/Popup.css";
import { MediaRecorder, register } from "extendable-media-recorder";
import { connect } from "extendable-media-recorder-wav-encoder";
import * as api from "../Scripts/Api";


export default class RecordButtonClass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startClick: null,
      endClick: null,
      finishClick: null,
      audioCtx: null,
      buttonState: "start",
      restartState: false,
      recordingDurationLimitInMs: 180 * 1000,
      recordingElapsedDuration: 0,
      recordingStartTimestamp: null,
      timeoutId: null,
    };

    this.setupAudio();
  }

  async setupAudio() {
    let bigThis = this;
    let chunks = [];
    if (navigator.mediaDevices.getUserMedia) {
      const constraints = { audio: true };
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      let audioCtx = new AudioContext();

      let port;
      try {
        port = await connect();

        try {
          await register(port);
        } catch (e2) {
          console.log("E2: " + e2);
        }
      } catch (e1) {
        console.log("E1: " + e1);
      }

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (mediaStream) {
          if (window.stream != null) {
            window.stream.getTracks().forEach((track) => track.stop());
          }
          window.stream = mediaStream;

          const mediaRecorder = new MediaRecorder(mediaStream, {
            mimeType: "audio/wav",
          });

          const source = audioCtx.createMediaStreamSource(mediaStream);
          const analyser = audioCtx.createAnalyser();
          let prompt_name = bigThis.props.name;

          let startClick = () => {
            console.debug("startClick handler. BEFORE mediaRecorder.state: ", mediaRecorder.state)
            if (mediaRecorder.state === "paused"){
              mediaRecorder.resume();
            } else {
              mediaRecorder.start();
            }

            bigThis.setState(
              {
                buttonState: "hide",
                restartState: true,
                recordingStartTimestamp: Date.now()
              },
              () => visualize(source, analyser)
            )

            let showStopButton = () => {
              bigThis.setState(
                {
                  buttonState: "stop"
                }
              );
              
              
              let timelimit = bigThis.state.recordingDurationLimitInMs;
              let alreadyUsed = bigThis.state.recordingElapsedDuration;
              let remainingTime = timelimit - alreadyUsed;
              if (remainingTime < 0){
                remainingTime = 0;
              }
              
              console.log("timelimit: ", timelimit);
              console.log("alreadyUsed: ", alreadyUsed);
              console.log("remainingTime: ", remainingTime);

              bigThis.setState({timeoutId: setTimeout(forceEndRecording, remainingTime)});
              console.log("timeout set to ", remainingTime, " milliseconds.");
              
              console.debug("startClick handler. AFTER mediaRecorder.state: ", mediaRecorder.state);
            }

            setTimeout(showStopButton, 3000)

          };

          let forceEndRecording = () => {
            console.debug("time expired, forcing the end of the recording...");
            if (mediaRecorder.state === "recording") {
              mediaRecorder.stop();
            }
          };

          let userEndRecording = () => {
            console.debug("user stopped/paused the recording...");
            if (mediaRecorder.state === "recording") {
              clearTimeout(bigThis.state.timeoutId);
              mediaRecorder.pause();
            }
          };

          let endClick = () => {
            undoViz();
            userEndRecording();
            let stopTimestamp = Date.now();

            console.log("> starting timestamp: ", bigThis.state.recordingStartTimestamp)
            console.log("> stopped timestamp: ", stopTimestamp);
            let elapsedMillis = stopTimestamp - bigThis.state.recordingStartTimestamp;
            console.log("> this elapsed time (ms): ", elapsedMillis);
            let prevElapsedMillis = bigThis.state.recordingElapsedDuration;
            console.log("> previous elapsed millis: ", prevElapsedMillis);

            bigThis.setState(
              {
                recordingElapsedDuration: prevElapsedMillis + elapsedMillis,
              }, () => console.log("> new elapsed millis: ", bigThis.state.recordingElapsedDuration)
            );

            bigThis.setState({
              buttonState: "start",
              restartState: true,
            });
          };

          bigThis.state.startClick = startClick;
          bigThis.state.endClick = endClick;
          bigThis.setState({
            endClick: endClick,
            startClick: startClick,
          });

          let finishClick = () => {
            console.log("finishClick called");
            if (mediaRecorder.state === "recording" || mediaRecorder.state === "paused") {
              mediaRecorder.stop();
            }
            if (bigThis.props.onStop) {
              bigThis.props.onStop();
            } 
          };

          bigThis.state.finishClick = finishClick;
          bigThis.setState({
            finishClick: finishClick
          });

          mediaRecorder.ondataavailable = function (e) {
            console.log("logging recording");
            console.log('chunks.length: ', chunks.length)
            chunks.push(e.data);
            console.log('chunks.length: ', chunks.length)
            if (mediaRecorder.state === 'inactive'){
              console.debug('mediaRecorder.state is inactive/stopped. chunks...');
              console.debug('chunks.length: ', chunks.length);
              chunks.forEach(blob => {
                console.debug('chunk blob, blob.type: ', blob.type, ', blob.size: ', blob.size,)
              });
              console.debug('---chunks---');
  
              var blob = new Blob(chunks, {
                type: "audio/wav",
              });
              
              api.upload_attachment(
                prompt_name,
                blob,
                prompt_name + ".wav",
                "audio/wav"
              );
            }
          };
        })
        .catch(function (err) {
          if (err.name === "NotAllowedError") {
            alert(
              "Allowing access to the microphone is neccessary to successfully complete these next questions. To allow access, refresh this page and go through the prompts again, or allow access in settings."
            );
          }

          console.log(err.name + ": " + err.message);
        });
    }
    function undoViz() {
      const canvas = document.querySelector(".visualizer");
      const canvasCtx = canvas.getContext("2d");
      const WIDTH = canvas.width;
      const HEIGHT = canvas.height;
      canvasCtx.fillStyle = "rgb(256, 256, 256)";
      canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);
    }

    function visualize(source, analyser) {
      analyser.fftSize = 2048;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);
      source.connect(analyser);

      draw();

      function draw() {
        if (
          ( bigThis.state.buttonState === "stop" || bigThis.state.buttonState === "hide" ) &&
          document.querySelector(".visualizer")
        ) {
          const canvas = document.querySelector(".visualizer");

          const canvasCtx = canvas.getContext("2d");
          const WIDTH = canvas.width;
          const HEIGHT = canvas.height;

          requestAnimationFrame(draw);

          analyser.getByteTimeDomainData(dataArray);

          canvasCtx.fillStyle = "rgb(256, 256, 256)";
          canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

          canvasCtx.lineWidth = 2;
          canvasCtx.strokeStyle = "rgb(0, 0, 0)";

          canvasCtx.beginPath();

          let sliceWidth = (WIDTH * 1.0) / bufferLength;
          let x = 0;

          for (let i = 0; i * 20 < bufferLength; i++) {
            let v = (dataArray[i * 20] / 128.0 - 1) * 4 + 1;
            let y = (v * HEIGHT) / 2;

            if (i === 0) {
              canvasCtx.moveTo(x, y);
            } else {
              canvasCtx.lineTo(x, y);
            }

            x += sliceWidth * 20;
          }

          canvasCtx.lineTo(canvas.width, canvas.height / 2);
          canvasCtx.stroke();
        }
      }
    }

  }

  render() {
    let startButton = "";
    let stopButton = "";
    let restartButton = "";
    let finishButton = "";


    let prefLang = sessionStorage.getItem("preferredLanguage")
    let startText = prefLang !== "ES" ? "🔴 Tap here to start audio recording" : "🔴 Toque aquí para iniciar la grabación de audio"
    let stopText = prefLang !== "ES" ? "🟥 Tap here when you are finished speaking" : "🟥 Toque aquí cuando hayas terminado de hablar"
    let resumeText = prefLang !== "ES" ? "🔴 Tap here to record again" : "🔴 Toque aquí para grabar de nuevo"
    let finishText = prefLang !== "ES" ? "🡺 Tap to save recording and continue" : "🡺 Toque para guardar la grabación y continuar"

    startButton = (
      <button
        className="record-start-button"
        id="record-start-button"
        onClick={() => {
          this.state.startClick();
        }}
      >
        {startText}
      </button>
    );

    stopButton = (
      <button
        className="record-stop-button"
        id="record-stop-button"
        onClick={() => {
          this.state.endClick();
        }}
      >
      {stopText}
      </button>
    );

    restartButton = (
      <button style={{margin: '30px'}}
        className="record-restart-button"
        id="restart-button"
        onClick={() => {
          this.state.startClick();
        }}
      >
        {resumeText}
      </button>
    );

    finishButton = (
      <button style={{margin: '10px'}}
        className="record-finish-button"
        id="finish-button"
        onClick={() => {
          let endStoryTime = new Date().getTime();
          console.log("END Time Story!!: ", endStoryTime);
          sessionStorage.setItem("endStory", endStoryTime);
          let timeSpentStory =
            endStoryTime - sessionStorage.getItem("startStory");
          console.log("TIME SPENT FOR STORY!!!: ", timeSpentStory);
          console.log("TIME SPENT FOR STORY in seconds!!!: ", timeSpentStory/1000.0);
          api.record_prompt_response("STORY_TIME", timeSpentStory/1000.0);
          this.state.finishClick();
        }}
      >
        {finishText}
      </button>
    );

    let button1 = "";
    let button2 = "";
    if (this.state.restartState === true) {
      button2 = restartButton;
      button1 = finishButton;
    } else {
      button1 = startButton;
    }
    //let
    if (this.state.buttonState === "stop") {
      button1 = stopButton;
      button2 = "";
    } else if (this.state.buttonState === "hide"){
      button1 = "";
      button2 = "";
    }
    /*if (this.state.restartState === true && this.state.buttonState === "stop") {
   
      button2 = restartButton
  } */

    return (
      <div className="button-container" id="button-container">
        <canvas className="visualizer" id="visualizer" height="40px"></canvas>
        <br />
        {button1}
        {button2}
      </div>
    );
  }
}
